import axios from 'axios'
import config from '@/config'

const state = () => ({
  user: null,
  email: null
})

const mutations = {
  SET_USER(state, payload) {
    state.user = payload
  },
  SET_EMAIL(state, email) {
    state.email = email
  }
}

const actions = {
  CHECK({commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'auth/check', rootGetters.getRequestConfig)
        .then(resp => {
          commit('SET_USER', resp.data)
          commit('SET_EMAIL', resp.data.email)
          resolve(resp)
        })
        .catch(() => {
          commit('SET_USER', null)
          reject(null)
        })
    })
  },
  CHANGE_PASSWORD({commit, rootGetters}, password) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'auth/change-password', password, rootGetters.getRequestConfig)
        .then(resp => {
          commit('SET_USER', null)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  LOGIN({commit}, user) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'auth/login', user)
        .then(resp => {
          commit('SET_USER', resp.data)
          resolve(resp)
        })
        .catch(err => {
          commit('SET_USER', null)
          reject(err)
        })
    })
  },
  RESET_PASSWORD({commit}, email) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'auth/reset-password', email)
        .then(resp => {
          commit('SET_USER', null)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  LOG_OUT({commit, rootGetters, state}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'auth/logout', rootGetters.getRequestConfig)
        .then(() => {
          commit('SET_USER', null)
          localStorage.setItem('email-old', state.email)
          resolve()
        })
        .catch(() => {
          commit('SET_USER', null)
          reject()
        })
    })
  },
  RESET_TOKEN({commit, rootGetters}, uuid) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'auth/reset-token/' + uuid, rootGetters.getRequestConfig)
        .then(resp => {
          commit('SET_USER', {token: resp.data.accessToken})
          resolve()
        })
        .catch(() => {
          commit('SET_USER', null)
          reject()
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
